// My bookings — this device's identity at this store: every booking it
// made, newest first as the server lists them, each with the store's
// answer. A row opens the booking's own page.

import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router';
import { BOOKING_STATUS_LABEL, dateLabel, fetchMyBookings, timeLabel, type Booking } from '../../lib/api';

export function MyBookings() {
  const { rid, sid } = useParams() as { rid: string; sid: string };
  const [bookings, setBookings] = useState<Booking[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetchMyBookings(rid, sid).then(setBookings, (e) => setError(e instanceof Error ? e.message : 'Could not load your bookings.'));
  }, [rid, sid]);

  return (
    <div className="mo-page">
      <header className="co-head">
        <Link to={`/r/${rid}/s/${sid}`} className="co-backbtn" aria-label="Back to the menu">‹</Link>
        <div><h1>My bookings</h1></div>
        <Link to={`/r/${rid}/s/${sid}/book`} className="linky bk-mine">Book a table</Link>
      </header>
      {error && <div className="co-err bk-err" role="alert">{error}</div>}
      {bookings === null && !error && <div className="loading">Looking…</div>}
      {bookings?.length === 0 && (
        <div className="co-sec"><p className="bk-lede">No bookings yet — <Link to={`/r/${rid}/s/${sid}/book`} className="linky">book a table</Link>.</p></div>
      )}
      <div data-section="my-bookings">
        {bookings?.map((b) => (
          <Link key={b.bookingId} to={`/r/${rid}/s/${sid}/bookings/${b.bookingId}`} className="co-sec mo-row" data-booking={b.bookingId} data-status={b.status}>
            <span className={'mo-status bk-status ' + b.status}>{BOOKING_STATUS_LABEL[b.status]}</span>
            <span className="mo-what">
              {dateLabel(b.bookingDate)} · {timeLabel(b.bookingTime)} · {b.pax} {b.pax === 1 ? 'guest' : 'guests'}
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
}
